import axios from "axios/index";
import api from "../../config/_api";
import {SYSTEMS_UPDATED} from "../actions/systems";

const state = {
    systems: []
};
const actions = {
    getSystems: ({commit, rootGetters}) => {
        axios({url: api.url + 'systems?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('SYSTEMS_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
    freeSystem ({commit, rootGetters}){
        axios({url: api.url + 'systems/freeSystems?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('SYSTEMS_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
    archiver({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        params.append('status', payload.status);
        params.append('structure_id', rootGetters.structure_id);
        
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'systems/' + payload.id, params)
            .then((response) => {
                commit('removeSystem', payload.id);
                commit('SYSTEMS_UPDATED', state.systems);
             //   commit('addSystem', response.data);
                //const dataArray = Object.values(response.data);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
        
    },
    
    appliquer({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        //params.append('status', payload.status);
        params.append('type_id', payload.type_id);
        params.append('name', payload.name);
        params.append('manufacturer_id', payload.manufacturer_id);
        params.append('responsible_id', payload.responsible_id);
        params.append('empreinte_CO2', payload.empreinte_CO2);
        params.append('structure_id', rootGetters.structure_id);
        params.append('resume', true);
        
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'systems/' + payload.id, params)
            .then((response) => {
                //commit('SYSTEMS_UPDATED', response.data);
                //commit('removeSystem', payload.id);
                //commit('addSystem', response.data);
                commit('replaceSystem', response.data);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
        
    },
    seuil({commit, rootGetters}, payload) {
        const params = new URLSearchParams();
        
        params.append('seuil_hors_resa', payload.seuil);
        params.append('structure_id', rootGetters.structure_id);
        
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'systems/' + payload.id, params)
            .then((response) => {
                //commit('SYSTEMS_UPDATED', response.data);
                //commit('removeSystem', payload.id);
                commit('replaceSystem', response.data);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
        
    },
    
};
const mutations = {
    [SYSTEMS_UPDATED]: (state, systems) => {
        state.systems = systems;
    },
    ['addSystem']: (state, system) => {
        state.systems.push(system);
    },
    ['removeSystem']: (state, id) => {
        var index = state.systems.findIndex(event => event.id === id);
        state.systems.splice(index, 1);
    },
    ['replaceSystem']: (state, system) => {
        var index = state.systems.findIndex(event => event.id === system.id);
       // state.systems[index] = system;

        state.systems.splice(index, 1);
        state.systems.push(system);

        state.systems.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        
    },
    
};
const getters = {
    systems : state => state.systems,
    
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
//# sourceMappingURL=systems.js.map